export enum CorrectAnswerCategoryEnum {
  Noun = 'Noun',
  Person = 'Person',
  Verb = 'Verb',
  Number = 'Number',
  Geography = 'Geography',
  Health = 'Health',
  Letter = 'Letter',
}
